import { useEffect } from 'react';
import { UserDetails } from '../../../pages';
import { IPage } from '../../../pages/types';
import { WithRouteData } from '../../../render-routes';
import {
  sendManagerEvent,
  useUserCtxSelector,
  useUserStateMatches,
} from '../../../xstate/app.xstate';
import { NEW_USER_TEMP_ID } from '../../../xstate/user-details-xstate-helper';
import { getLoggedInUserHighestRole } from '../../../xstate/permission-details-xstate-helper';

export const UserDetailsPage = ({
  userId,
  orgId,
  ...props
}: IPage & { userId: string; orgId: string }) => {
  const isInviteUser = userId === NEW_USER_TEMP_ID;
  const loadedLoggedInUserDetails = useUserStateMatches('loggedIn.loaded');
  const { assignedRoles, assignedTeams } = useUserCtxSelector((ctx) => ({
    assignedRoles: ctx.user?.assignedRoles,
    assignedTeams: ctx.user?.assignedTeams,
  }));

  const loggedInUserHighestRole = getLoggedInUserHighestRole(
    assignedRoles,
    assignedTeams
  );

  useEffect(() => {
    if (loadedLoggedInUserDetails && orgId) {
      if (isInviteUser) {
        sendManagerEvent({
          type: 'manager.addNewUser',
          orgId: orgId,
          loggedInUserHighestRole: loggedInUserHighestRole || {},
        });
      } else {
        if (userId) {
          sendManagerEvent({
            type: 'manager.loadUserDetails',
            orgId: orgId,
            userId: userId,
            loggedInUserHighestRole: loggedInUserHighestRole || {},
          });
        }
      }
    }
  }, [
    userId,
    orgId,
    isInviteUser,
    loggedInUserHighestRole,
    loadedLoggedInUserDetails,
  ]);

  useEffect(() => {
    return () => {
      sendManagerEvent({
        type: 'manager.userDetails.discardUpdates',
        userId: userId,
      });
      sendManagerEvent({
        type: 'manager.clearSelectedUser',
      });
    };
  }, [userId]);

  return <UserDetails {...props} isInviteUser={isInviteUser} />;
};

export default WithRouteData(UserDetailsPage);
